import React, { FunctionComponent, useEffect, useState } from 'react';
import Styles from 'views/emailNotifications/EmailNotifications.module.scss';
import SwitchButton from 'components/button/switchButton/SwitchButton';
import SettingsActionButtons from 'components/settingsActionButtons';
import { emailNotifications } from 'store/services/firebase-broadcast';
import Toast from 'components/toast/Tost';

interface EmailNotificationProps {
  getSettingRequest: Function;
  updateSetting: Function;
  setting: boolean;
  settingSuccess: string;
  checkEmailNotify?: { checked?: boolean } | null;
}

const EmailNotifications: FunctionComponent<EmailNotificationProps> = (props: EmailNotificationProps) => {
  const { checkEmailNotify } = props;
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const initialChecked = checkEmailNotify?.checked ?? true;
  const [checked, setChecked] = useState(initialChecked);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastValues, setToastValues] = useState({ message: '', type: '' });

  const handleCancel = () => {
    setChecked(checkEmailNotify?.checked ?? true);
  };

  const handleChange = () => {
    setChecked(!checked);
  };

  const handleUpdate = () => {
    setLoading(true);
    setTimeout(() => {
      emailNotifications({
        pk: user.pk,
        email: user.email,
        checked,
      });
      setToast(true);
      setToastValues({
        message: 'Your changes have been saved.',
        type: 'Success',
      });
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    setChecked(checkEmailNotify?.checked ?? true);
  }, [checkEmailNotify]);

  return (
    <>
      <div className={Styles.settingsContent}>
        <div className={Styles.pageCard}>
          <div className={Styles.rowText}>
            <div className={Styles.titleRow}>
              <p className={Styles.rowTitle}>Email unread room messages</p>
              <span className={Styles.switchSlot}>
                <SwitchButton isChecked={checked} handleChange={handleChange} />
              </span>
            </div>
            <span className={Styles.rowSubtitle}>
              Get an email when you have unread messages in a room
            </span>
          </div>
        </div>
      </div>
      <SettingsActionButtons
        onCancel={handleCancel}
        onSave={handleUpdate}
        saving={loading}
      />
      {toast && (
        <Toast
          message={toastValues.message}
          position="topRight"
          type={toastValues.type}
          handleCloseToast={setToast}
        />
      )}
    </>
  );
};

export default EmailNotifications;
